module.exports = __webpack_public_path__ + "static/media/carousel3.c47cbd02.png";